import { ChevronRight } from 'lucide-react'
import { useNavigate, useLocation } from '@tanstack/react-router'

const modules = [{ id: 'rewards', label: 'Rewards', icon: '🎁', path: '/rewards' }]

export function Sidebar() {
  const navigate = useNavigate()
  const location = useLocation()
  const currentPage = modules.find(module => module.path === location.pathname)?.id || 'dashboard'

  return (
    <div className="w-[200px] min-h-screen bg-sidebar border-r border-border flex flex-col">
      <div className="p-4 border-b border-border">
        <div className="flex items-center gap-2">
          <div className="bg-[#006837] text-white w-6 h-6 rounded flex items-center justify-center">
            <span className="text-sm">h</span>
          </div>
          <div className="flex flex-col">
            <span className="text-sm font-semibold">homebody</span>
            <span className="text-xs text-muted-foreground">RXP STUDIO</span>
          </div>
        </div>
      </div>

      <nav className="flex-1 p-2">
        <div className="mb-2">
          <p className="text-xs text-muted-foreground px-2 py-1">Modules</p>
        </div>
        <ul className="space-y-1">
          {modules.map(module => (
            <li key={module.id}>
              <button
                className={`w-full flex items-center gap-2 p-2 rounded-md ${
                  currentPage === module.id
                    ? 'bg-accent text-primary'
                    : 'text-sidebar-foreground hover:bg-accent/50'
                }`}
                onClick={() => navigate({ to: module.path as any })}
              >
                <span className="w-5 text-center">{module.icon}</span>
                <span className="text-sm">{module.label}</span>
                {currentPage === module.id && <ChevronRight className="ml-auto w-4 h-4" />}
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  )
}
